import axios from "axios"
import { baseURL, config, requestID } from "../../common/utils"




export const getStaffList = async () => {
    const payload = {
        requestID: requestID(),
    }

    try {
        const res = axios.post(`${baseURL}warehouses/getStaffList`, payload, config)        
    } catch (error) {
        console.error(error);
    }


}



export const getProductsByBranch = async (branchId) => {
    const data = {
        requestID: requestID(),
                branch_id: branchId,

    };

  //console.log(getToken());
    try {
        const res = await axios.post(`${baseURL}warehouses/getProductsByBranch`, data, config)
        console.log(res)
        return res.data

    } catch (error: any) {
        return error
    }
};

export const getTlocations_production_centre = async () => {
    const payload = {
        requestID: requestID(),
    }

    try {
        const res = axios.post(`${baseURL}businesss/getTlocations_production_centre`, payload, config)     
        console.log(res)
        return res   
    } catch (error) {
        console.error(error);
    }


}


export const getTlocations = async () => {
    const payload = {
        requestID: requestID(),
    }

    try {
        const res = axios.post(`${baseURL}businesss/getTlocations`, payload, config)     
        console.log(res)
        return res   
    } catch (error) {
        console.error(error);
    }


}


export const transferStocks = async (data) => {

    const payload = {
        requestID: requestID(),
        payload: data
    }

    try {
        const res = axios.post(`${baseURL}warehouses/transferStock`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}




export const getTotalStockPerProduct = async () => {

    const payload = {
        requestID: requestID(),
    }

    try {
        const res = axios.post(`${baseURL}warehouses/getTotalStockPerProduct`, payload, config)
        console.log(res)
        return res
    } catch (error) {

        return error
    }
}

export const getStocksTransfer = async () => {

    const payload = {
        requestID: requestID(),
    }

    try {
        const res = axios.post(`${baseURL}warehouses/getStocksTransfer`, payload, config)
        console.log(res)
        return res
    } catch (error) {

        return error
    }
}


export const addBarRequest = async (data) => {

    const payload = {
        requestID: requestID(),
        data: data
    }
    try {
        const res = axios.post(`${baseURL}warehouses/addBarRequest`, payload, config)
        console.log(res)
        return res
    } catch (error) {

        return error
    }
}

export const addStewardRequest = async (data) => {

    const payload = {
        requestID: requestID(),
        data: data
    }
    try {
        const res = axios.post(`${baseURL}warehouses/addStewardRequest`, payload, config)
        console.log(res)
        return res
    } catch (error) {

        return error
    }
}



export const deleteRequestOrder = async (data) => {
  
 const payload = {
 requestID: requestID(),...data
 }

    try {
        const res = axios.post(`${baseURL}warehouses/deleteRequestOrder`, payload, config)
        console.log('resssss', res)
        return res
    } catch (error) {

        return error
    }
}
export const deleteBarRequestOrder = async (data) => {
  
 const payload = {
 requestID: requestID(),...data
 }

    try {
        const res = axios.post(`${baseURL}warehouses/deleteBarRequest`, payload, config)
        console.log('resssss', res)
        return res
    } catch (error) {

        return error
    }
}



export const getStewardBarRequestsWithItemss = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}warehouses/getStewardBarRequestsWithItems`, payload, config)
       
        return res
    } catch (error) {

        return error
    }
}
export const getStewardBarRequestsWithItems = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}warehouses/getStewardBarRequestsWithItems`, payload, config)
        console.log('resssss', res)
        return res
    } catch (error) {

        return error
    }
}

export const getMyBarRequestsWithItems_branch = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}warehouses/getMyBarRequestsWithItems_branch`, payload, config)
        console.log('resssss', res)
        return res
    } catch (error) {

        return error
    }
}
export const getMyBarRequestsWithItems = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}warehouses/getMyBarRequestsWithItems`, payload, config)
        console.log('resssss', res)
        return res
    } catch (error) {

        return error
    }
}



export const getPendingBarRequestsWithItems_sales = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}warehouses/getPendingBarRequestsWithItems_sales`, payload, config)
        return res
    } catch (error) {

        return error
    }
}

export const getPendingBarRequestsWithItems = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}warehouses/getPendingBarRequestsWithItems`, payload, config)
        return res
    } catch (error) {

        return error
    }
}
export const getPendingStewardRequestsWithItems = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}warehouses/getPendingStewardRequestsWithItems`, payload, config)
        return res
    } catch (error) {

        return error
    }
}

export const getAllBarRequestsWithItems = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}warehouses/getAllBarRequestsWithItems`, payload, config)
        console.log('resssss', res)
        return res
    } catch (error) {

        return error
    }
}




export const approveBarRequest_branch = async (data) => {

    const payload = {
        requestID: requestID(),
        data: data
    }

    // return payload;
    try {
        const res = axios.post(`${baseURL}warehouses/approveBarRequest_branch`, payload, config)
        console.log('hello2', res);
        return res
    } catch (error) {

        return error
    }
}
export const approveBarRequest = async (data) => {
    const payload = {
        requestID: requestID(),
        data: data
    }

    // return payload;
    try {
        const res = axios.post(`${baseURL}warehouses/approveBarRequest`, payload, config)
        
        return res
    } catch (error) {

        return error
    }
}
export const approveStewardRequest = async (data) => {

    const payload = {
        requestID: requestID(),
        data: data
    }
    try {
        const res = axios.post(`${baseURL}warehouses/approveStewardRequest`, payload, config)
        
        return res
    } catch (error) {

        return error
    }
}